<template>
	<div class="news-edit">
		<section>
			<b-field label="ニュースカテゴリ">
				<b-select v-model="categoryId">
					<option value="">未選択</option>
					<option
						v-for="row in categories"
						:value="row.id"
						:key="row.id">
						{{ row.name }}
					</option>
				</b-select>
			</b-field>

			<div class="input-wrap">
				<div class="sv-field">
					<input type="text" class="sv-input" :class="{ 'is-danger': $utils.hasError(errors, 'title') }" v-model="title" placeholder="タイトル（必須）"/>
				</div>
				<span class="error-message" v-show="errors.title">{{ errors.title }}</span>
			</div>

			<div class="input-wrap">
				<div class="sv-field">
					<textarea class="sv-textarea" v-model="body" placeholder="本文" rows="4"></textarea>
				</div>
				
			</div>

			<b-field class="file mt-20 max-w-button">
				<b-upload v-model="image" class="max-w-button" @input="onImageChange" :loading="isImageLoading" v-show="images.length <= 2">
					<a class="button is-success horizontal-center">
						<span>写真を追加</span>
						<img :src="require('@/assets/icons/camera.svg')"/>
					</a>
				</b-upload>
			</b-field>

			<div style="text-align: center;">写真は3枚まで挿入できます</div>
			<div class="mb-20" style="text-align: center;">ドラッグ＆ドロップで並び替えできます</div>

			<loader class="mb-20" v-show="isImageLoading"></loader>

			<draggable
				class="image-list"
				@start="onStart"
				@end="onEnd"
				@add="onAdd"
				@update="onUpdate"
				@sort="onSort"
				@remove="onRemove"
				@filter="onFilter"
				@move="onMove"
				@clone="onClone"
				@change="onChange"
				v-model="images"
				handle=".my-handle"
				>
				<div class="image-wrap" v-for="(row, index) in images" :key="index">
					<preview :image="row" :maxH="200" :isDeleteButtonShow="true" @delete-click="onImageRemoveClick(index)"></preview>
					<!--
					<i class="far fa-trash-alt image-remove" @click="onImageRemoveClick(index)"></i>
					-->
				</div>
			</draggable>
		</section>

		<b-button class="max-w-button mt-20" type="is-primary" rounded :loading="isSubmitLoading" @click="isModalActive = true">投稿</b-button>
		<b-button class="max-w-button mt-20 mb-20" type="is-primary" rounded :loading="isDraftLoading" @click="onDraftClick">下書き保存</b-button>
		<b-button class="max-w-button" type="is-info" rounded @click="$router.go(-1)">キャンセル</b-button>

		<b-modal :active.sync="isModalActive">
			<confirm-modal title="投稿確認" body="記事を投稿します。よろしいですか？" okButtonTitle="投稿する" @ok-click="onModalOkClick" @cancel-click="isModalActive = false"></confirm-modal>
		</b-modal>
	</div>
</template>

<style lang="scss" scoped>
@import '@/scss/_vars.scss';

.file {
	.button {
		font-size: 18px;
		font-weight: $extraBold;
	}
}

.image-list {
	width: 80%;
	text-align: center;
	margin: 0 auto;

	.image-wrap {
		display: inline-block;

		&:not(first-child) {
			margin-top: 10px;
		}

		img {
			cursor: move;
		}
	}
}

@media screen and (min-width: $breakPoint) {
	.image-list {
		.image-wrap {
			display: block;
		}
	}

	.news-edit {
		padding-left: 130px;
		padding-right: 130px;
	}
}
</style>

<script>
import draggable from 'vuedraggable'
import Loader from '@/components/Loader'
import ConfirmModal from '@/components/ConfirmModal'
import Preview from '@/components/Preview'

export default {
	name: 'NewsEdit',
	components: {
		draggable,
		Loader,
		ConfirmModal,
		Preview,
	},
	data () {
		return {
			isModalActive: false,
			categoryId: '',
			title: '',
			body: '',
			errors: {
				title: '',
			},
			images: [],
			//images: [
			//	'http://192.168.24.50:96/files/news/b7378e2e-3ff9-42f3-9eec-90bf24a34b96_20200107004651.jpg',
			//	'http://192.168.24.50:96/files/news/4556ae68-892f-49c4-9a41-eee71f0110e7_20200107011356.jpg'
			//],
			image: null,
			categories: [],
			isSubmitLoading: false,
			isImageLoading: false,
			isDraftLoading: false,
		}
	},
	created() {
	},
	mounted() {
		this.init();
	},
	methods: {
		onImageRemoveClick: function(index) {
			this.images.splice(index, 1);
		},
		// Element dragging ended
		onEnd: function (/**Event*/evt) {
			this.$utils.log('onEnd');
			//var itemEl = evt.item;  // dragged HTMLElement
			//console.log(evt.to);    // target list
			//console.log(evt.from);  // previous list
			//console.log(evt.oldIndex);  // element's old index within old parent
			//console.log(evt.newIndex);  // element's new index within new parent
			//console.log(evt.oldDraggableIndex); // element's old index within old parent, only counting draggable elements
			//console.log(evt.newDraggableIndex); // element's new index within new parent, only counting draggable elements
			//evt.to;    // target list
			//evt.from;  // previous list
			//evt.oldIndex;  // element's old index within old parent
			//evt.newIndex;  // element's new index within new parent
			//evt.oldDraggableIndex; // element's old index within old parent, only counting draggable elements
			//evt.newDraggableIndex; // element's new index within new parent, only counting draggable elements
			//evt.clone // the clone element
			//evt.pullMode;  // when item is in another sortable: `"clone"` if cloning, `true` if moving
			this.images = [];
			for (let i = 0; i < evt.to.children.length; i++) {
				this.$utils.log(evt.to.children[i].getElementsByTagName('img')[0].src);
				this.images.push(evt.to.children[i].getElementsByTagName('img')[0].src);
				//this.$utils.log(evt.to.children[i].children.item(0).src);
			}
		},
		onImageChange: function() {
			this.$utils.log(this.image);
			if (!this.image || !this.image.type.match(/^image\/(png|jpeg)$/)) {
				alert('画像ファイルを指定してください');
				return;
			}

			let reader = new FileReader();
			reader.readAsDataURL(this.image);
			reader.onload = (e) => {
				this.uploadImage(e.target.result);
			};
		},
		uploadImage: async function(file) {
			this.isImageLoading = true;

			let data = {
				image: file,
			};

			let ep = 'news/image';

			try {
				let res = await this.$api.post(ep, data, true);
				this.$utils.log(res);
				this.images.push(res.data.url);
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isImageLoading = false;
			}
		},
		onDraftClick: async function() {
			let ep = 'news/draft';
			this.$utils.log(ep);

			this.isDraftLoading = true;

			try {
				let res = await this.$api.post(ep, this.createSubmitData(), true);
				this.$utils.log(res);
				this.$router.push({ name: 'news' });
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isDraftLoading = false;
			}
		},
		onModalOkClick: async function() {
			this.isModalActive = false;

			for (let key in this.errors) {
				this.errors[key] = '';
			}

			let ep = 'news';
			this.$utils.log(ep);

			this.isSubmitLoading = true;

			try {
				let res = await this.$api.post(ep, this.createSubmitData(), true);
				this.$utils.log(res);
				this.$router.push({ name: 'news' });
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
				if (error.response.status === 400) {
					let details = error.response.data.details;
					for (let key in details) {
						this.errors[this.$utils.toCamelCase(key)] = details[key];
					}
				}
			} finally {
				this.isSubmitLoading = false;
			}
		},
		createSubmitData: function() {
			let data = {
				"id": this.id,
				"title": this.title,
				"body": this.body,
				"category_id": this.categoryId,
			};

			let img = '';
			if (this.images.length > 0) img = this.images;
			data.images = img;

			this.$utils.log(data);
			return data;
		},
		init: function() {
			this.getData();
		},
		getData: async function() {
			let loader = this.$buefy.loading.open();
			let params = this.$route.params.newsId ? '/' + this.$route.params.newsId: '';
			let ep = 'news/screen' + params;
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.id = res.data.id;
				this.categoryId = res.data.category_id;
				this.title = res.data.title;
				this.body = res.data.body;
				this.images = res.data.images;
				this.categories = res.data.categories;
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				loader.close();
			}
		},


		// Element dragging started
		onStart: function (/**Event*/evt) {
			this.$utils.log('onStart');
			//this.$utils.log(evt);
			//evt.oldIndex;  // element index within parent
		},

		// Element is dropped into the list from another list
		onAdd: function (/**Event*/evt) {
			this.$utils.log('onAdd');
			// same properties as onEnd
		},

		// Changed sorting within list
		onUpdate: function (/**Event*/evt) {
			this.$utils.log('onUpdate');
			// same properties as onEnd
		},

		// Called by any change to the list (add / update / remove)
		onSort: function (/**Event*/evt) {
			this.$utils.log('onSort');
			// same properties as onEnd
		},

		// Element is removed from the list into another list
		onRemove: function (/**Event*/evt) {
			this.$utils.log('onRemove');
			// same properties as onEnd
		},

		// Attempt to drag a filtered element
		onFilter: function (/**Event*/evt) {
			this.$utils.log('onFilter');
			var itemEl = evt.item;  // HTMLElement receiving the `mousedown|tapstart` event.
		},

		// Event when you move an item in the list or between lists
		onMove: function (/**Event*/evt, /**Event*/originalEvent) {
			this.$utils.log('onMove');
			// Example: https://jsbin.com/nawahef/edit?js,output
			evt.dragged; // dragged HTMLElement
			evt.draggedRect; // DOMRect {left, top, right, bottom}
			evt.related; // HTMLElement on which have guided
			evt.relatedRect; // DOMRect
			evt.willInsertAfter; // Boolean that is true if Sortable will insert drag element after target by default
			originalEvent.clientY; // mouse position
			// return false; — for cancel
			// return -1; — insert before target
			// return 1; — insert after target
		},

		// Called when creating a clone of element
		onClone: function (/**Event*/evt) {
			this.$utils.log('onClone');
			var origEl = evt.item;
			var cloneEl = evt.clone;
		},

		// Called when dragging element changes position
		onChange: function(/**Event*/evt) {
			this.$utils.log('onChange');
			evt.newIndex // most likely why this event is used is to get the dragging element's current index
			// same properties as onEnd
		},
	}
}
</script>
